var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col order-history pb-4"},[_c('h5',{staticClass:"myorders",attrs:{"id":"user-order-head","data-test":"ordersHeading"}},[_vm._v("\n      My Orders\n    ")]),(_vm.showLoader)?_c('page-loader'):_vm._e(),_c('router-link',{staticClass:"btn btn-link btn-orders-tab",class:(_vm.$route.path === '/user/order/orderedProducts')?'active':'',staticStyle:{"cursor":"pointer"},attrs:{"to":{
					path: '/user/order/orderedProducts',
					query: {
							display_text: 'My Orders'
						}
					},"tag":"button","data-test":"ordersProductsLink","id":"ordersProductsLink"}},[_vm._v("\n      Products\n    ")]),_c('router-link',{staticClass:"btn btn-link btn-orders-tab",class:(_vm.$route.path === '/user/order/orderedGiftCards')?'active':'',staticStyle:{"cursor":"pointer"},attrs:{"to":{
					path: '/user/order/orderedGiftCards',
					query: {
							display_text: 'My Orders'
						}
					},"tag":"button","data-test":"ordersGiftsLink","id":"ordersGiftsLink"}},[_vm._v("\n      Gift Cards\n    ")]),_c('hr'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }